<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen ">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            MARÍA WIESSE: <span class="fontMS500 colorPrincipal font-45">LETRA Y MÚSICA</span>
        </p>
        <p class="fontMS500 colorPrincipal font-24"></p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio39/maria-wiesse">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio39/maria-wiesse">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio39/maria-wiesse">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-000.png">
</section>

<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS300 text-center font-24">
                    <br><br>
                    EL 16 DE MARZO DE 2023, EL MINISTERIO DE CULTURA, DECLARÓ PATRIMONIO CULTURAL DE LA NACIÓN A VEINTICUATRO 
                    UNIDADES BIBLIOGRÁFICAS QUE CORRESPONDEN A LAS PRIMERAS EDICIONES DE TÍTULOS DE LA PRODUCCIÓN 
                    INTELECTUAL DE MARÍA WIESSE ROMERO (1894-1964).
                    <br><br>
                    <span class="fontMS300"> 
                        MARÍA WIESSE FUE UNA RECONOCIDA ESCRITORA, DIFUSORA CULTURAL Y PERIODISTA PERUANA. INCURSIONÓ 
                        EN POESÍA, CUENTO INFANTIL, ENSAYO BIOGRÁFICO, CRÍTICA MUSICAL Y CINEMATOGRÁFICA. SU AMPLIA 
                        PRODUCCIÓN VA UNIDA TANTO A UNA PROFUNDA SENSIBILIDAD ARTÍSTICA COMO A UN DESEO DE PROMOCIONAR 
                        DIVERSOS ASPECTOS CULTURALES LO QUE SE RELACIONA CON REFLEXIONES SOBRE LOS IDEALES DE MODERNIDAD DE 
                        SU TIEMPO.
                        <br><br>
                        ESTE MICROSITIO OFRECERÁ UNA VISIÓN EN CONJUNTO DE SU TRABAJO CREATIVO EN DISTINTAS FORMAS DE 
                        EXPRESIÓN QUE TENDIÓ PUENTES ENTRE MUNDOS CONTRAPUESTOS: ESPECIALISTAS Y LEGOS, NIÑOS Y ADULTOS Y 
                        TRADICIÓN Y MODERNIDAD. 
                    </span>
                    <br>
                </p>
                <div class="row p-5" style="display: flex; gap: 0;">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <div style="display: flex; width: 95%; ">
                            <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
                                <a href="http://hdl.handle.net/20.500.14428/81353" target="_blank" style="color: #ffffff;">
                                    <img  style="width:100%; height: auto; object-fit: cover;" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-001.png">
                                </a>
                            </div>
                            <div style="flex: 1; background-color: black; display: flex; justify-content: center; align-items: center; color: white; text-align: center;">
                                <p class="font-14">Exlibris de María Wiesse (1894-1964) <br>
                                    Disponible en: <a href="http://hdl.handle.net/20.500.14428/81353" target="_blank" style="color: #ffffff;">Biblioteca Digital</a></p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 220%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            ANTECEDENTES FAMILIARES<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>
                <!-- <div class="col-sm-1"></div> -->
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                </div>

                <div class="row ">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <p class="text-left  fontMS100 font-18">
                            <br><br>
                            SUS PADRES FUERON: TERESA ROMERO PAZ,
                            NATURAL DE LA CIUDAD DE CHICLAYO Y CARLOS
                            WIESSE PORTOCARRERO, UN DESTACADO
                            ABOGADO E HISTORIADOR NACIDO EN LA CIUDAD
                            DE TACNA. ASIMISMO, ES RECONOCIDO POR SU
                            LABOR CATEDRÁTICA EN LA UNIVERSIDAD
                            NACIONAL MAYOR DE SAN MARCOS, CUYA LABOR
                            DOCENTE FUE CATALOGADA POR JORGE BASADRE
                            DE LA SIGUIENTE MANERA: «WIESSE SIRVIÓ
                            DURANTE LARGOS AÑOS DE SEGURO NEXO ENTRE
                            LOS SABIOS Y LOS NIÑOS. LLEVÓ DE LA MANO A
                            MUCHAS GENERACIONES POR LAS TINIEBLAS DEL
                            PASADO NACIONAL, A VECES MARAVILLOSO, A
                            VECES TERRIBLE».
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-4">
                        <br><br>
                        <a href="https://hdl.handle.net/20.500.14428/12422" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-002.png">
                        </a>
                        
                        <p class="text-center fontMS100Italic text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;">
                            <br>
                            [Retrato de Carlos Wiesse Portocarrero]<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/12422" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-002.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «EL MEDIO EN QUE SE HA FORMADO MARÍA WIESSE, HA FAVORECIDO SUS INCLINACIONES LITERARIAS, 
                                TENIENDO COMO PRINCIPAL MAESTRO A SU ILUSTRE PADRE, EL DOCTOR CARLOS WIESSE, QUIEN HA 
                                CULTIVADO SIEMPRE LAS MEJORES RELACIONES EN LOS CÍRCULOS LITERARIOS, QUE A SU VEZ HAN 
                                FORMADO EL DE SU HIJA, Y LA HA PREPARADO ESA CIRCUNSTANCIA, A QUE TENGA SUFICIENTE ERUDICIÓN Y 
                                DISPONGA DE ESTILO PROPIO PARA EXPRESARSE».<br><br>
                                (LA MUJER PERUANA A TRAVÉS DE LOS SIGLOS / ELVIRA GARCÍA Y GARCÍA. TOMO II. 1925)  
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            MARÍA WIESSE Y LA NIÑEZ<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                </div>
                <p class="text-center  fontMS300 font-24">
                    <br><br>
                    EN DIVERSOS LIBROS Y ENSAYOS, MARÍA WIESSE DA A CONOCER DIVERSAS REFLEXIONES ACERCA 
                    DE LA INFANCIA. PARA ELLO UTILIZA UN LENGUAJE ASEQUIBLE A TODAS LAS PERSONAS, 
                    ESPECIALMENTE A LAS MADRES POCO LETRADAS. SU OBJETIVO FUE INTRODUCIRLAS A LA 
                    EXPERIENCIA ESTÉTICA.
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-003.png">
                    </div>
                    <div class="col-sm-3">
                        <br>
                    </div>
                </div>

                <div class="row  mt-5">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81796" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-004.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Rosario (historia de una niña) / 
                            María Wiesse. – Lima: Imp. Lux, 
                            1929.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81796" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81818" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-005.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Quipus: relatos peruanos para niños 
                            / por María Wiesse ; maderas de José 
                            Sabogal. – Lima: Imp. “La Voce 
                            d´Italia”, 1936.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81818" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81827" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-006.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            el niño, ese desconocido / maría 
                            Wiesse. – lima: [compañía de 
                            impresiones y publicidad], 1949.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81827" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81807" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-007.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Infancia / María Wiesse. Amauta. 
                            Año III, no. 16 (jul. 1928). Pág. 32.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81807" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/48738" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-008.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Cuentos de hadas / María Wiesse. 
                            Lima, 8, 9 y 11 set. 1939. 27 ff.
                            Manuscrito ológrafo.
                            <br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/48738" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81873" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-009.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El Imperio Incaico / María Wiesse. 
                            Peruanidad: órgano antológico del 
                            pensamiento nacional. Vol. II, no. 3 
                            (ene. 1942). Pág. 42.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81873" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 220%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            MARÍA WIESSE Y EL CINE<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>
                <!-- <div class="col-sm-1"></div> -->
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                </div>

                <div class="row ">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-4">
                        <br><br>
                        
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-010.jpe">
                        
                        <p class="text-center fontMS100Italic text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;">
                            <br>
                            Fotografía de María Wiesse.<br><br>
                            Disponible en: Archivo de Arte Peruano <br><a href="https://archi.pe/obra/48252" target="_blank" style="color: #ffffff;">https://archi.pe/obra/48252</a>
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <br><br>
                        <p class="text-left text-white fontMS100 font-18">
                            <br><br><br><br>
                            MARÍA WIESSE ES UNA PRECURSORA DE LA CRÍTICA DE 
                            CINE EN EL PERÚ Y EN AMÉRICA LATINA. ES UNA DE 
                            LAS PRIMERAS MUJERES EN LA HISTORIA DEL SIGLO XX 
                            EN ABORDAR EL CINE DESDE UNA ESCRITURA 
                            REFLEXIVA, CON CRITERIOS CLAROS Y DEFINIDOS. EN 
                            ESE SENTIDO, DEFENDIÓ EL VALOR ARTÍSTICO DE LAS 
                            PELÍCULAS CONSIDERÁNDOLAS COMO «EXPRESIONES 
                            RICAS Y BRILLANTES DE BELLEZA».
                            <br>
                        </p>

                    </div>
                    <div class="col-sm-1"></div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81842" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-011.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El cinema en Lima / Myriam [seud.].
                            Revista de actualidades: semanario
                            ilustrado. No. 16 (13 oct. 1917). Pág. 5.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81842" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81846" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-012.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Wiesse, María. Señales de nuestro
                            tiempo. Amauta. Año I, no. 4 (dic. 1926).
                            Pág. 13-14.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81846" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81805" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-013.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Wiesse, María. Los problemas del
                            cinema. Amauta. Año III, no. 12 (feb.
                            1928). Pág. 26-27.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81805" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81809" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-014.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000 ; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Wiesse, María. El hombre que se parecía
                            a Adolfo Menjou. Amauta. Año IV, no. 23
                            (may. 1929). Pág. 46-53.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81809" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81887" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-015.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La palabra frente a la imagen / María
                            Wiesse. Variedades : revista semanal
                            ilustrada. Año XXVI, no. 1154 (16 abr.
                            1930). Pág. 30-31.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81887" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81888" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-016.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-11" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Mas [sic] sobre Jesús : un libro y un film /
                            María Wiesse. Variedades : revista
                            semanal ilustrada. Año XXVI, no. 1163
                            (18 jun. 1930). Pág. 8-9.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81888" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-002.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «LAS ACTIVIDADES DIFUSORAS DE ESTA LITERATA, MELÓMANA Y CINÉFILA TENDIERON PUENTES ENTRE
                                MUNDOS CONTRAPUESTOS. RESEÑÓ COMO ESPECIALISTA PARA LOS LETRADOS, GUIO MUSICALMENTE A LAS
                                MADRES Y A LAS NOVATAS, EXALTÓ A LAS JUVENTUDES CON RELATOS ÉPICOS RELUMBRANTES, CONTRIBUYÓ
                                CON SU BIOGRAFÍA INAUGURAL DE MARIÁTEGUI A FORMAR LA CONCIENCIA POLÍTICA POPULAR, Y
                                EMBELLECIÓ Y DIGNIFICÓ LA VIDA EN ESTAS RIBERAS. FIEL A LA MEMORIA DE SU MARIDO, DEFENDIÓ HASTA
                                EL FIN SU BANDERA NACIONALISTA. NO EXENTA DE PASAJES DISCUTIBLES Y NEBLINOSOS EN LOS QUE
                                PRETENDE ESCRIBIR UNA VERSIÓN “OFICIAL” DE VIEJAS CONTROVERSIAS, SU SEMBLANZA DE SABOGAL
                                RECONSTRUYE LA TRAYECTORIA PERSONAL MÁS INFLUYENTE, Y SIN DUDA MÁS ATACADA, DE LA CREACIÓN
                                VISUAL PERUANA».<br><br>
                                (LETRA Y MÚSICA DE MARÍA WIESSE / RICARDO WIESSE. 2014)
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            MARÍA WIESSE Y LA MÚSICA<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                </div>
                <p class="text-justify fontMS300 font-24">
                    <br><br>
                    LA MÚSICA FUE UNA DE LAS MÁS GRANDES PASIONES DE MARÍA WIESSE. NO SOLO PUBLICÓ
                    LIBROS Y ARTÍCULOS QUE MOSTRABAN SU VASTO CONOCIMIENTO Y ALTA SENSIBILIDAD FRENTE A
                    ESTA EXPRESIÓN ARTÍSTICA SINO QUE, ADEMÁS, EN 1930, PARTICIPÓ EN LA CREACIÓN DE LA
                    REVISTA MUSICAL ANTARA, CONJUNTAMENTE CON EL MÚSICO BELGA ANDRÉS SAS, Y EN LA
                    DÉCADA DEL CUARENTA, PREPARÓ VARIOS PROGRAMAS DEDICADOS AL CANCIONERO POPULAR
                    PERUANO EN RADIO NACIONAL.
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-017.png">
                            <br>
                    </div>
                    <div class="col-sm-3">
                        <br>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81804" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-018.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Viaje al país de la música / María
                            Wiesse. – Lima: [Imp. “Gmo. Lenta”],
                            1943.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81804" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81791" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-019.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            la flauta de marsías (leyendas de la
                            música) / maría wiesse ; 14 tintas de
                            josé sabogal. – lima: [Talls. de la Cía. de
                            Imp. y Pub.], 1950.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81791" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81826" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-020.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            el mensaje de la música / ensayo por
                            maría wiesse. – lima: [Cía. de
                            Impresiones y Publicidad], 1952.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81826" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row mt-5">
                    
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/49226" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-021.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Composiciones musicales de Maurice
                            Ravel] / [María Wiesse]. [Lima]: s/f. 24
                            ff. Manuscrito<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/49226" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81896" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-022.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El estreno de Ollanta / Myriam
                            [seud.]. Variedades : revista semanal
                            ilustrada. Año XVII, no. 656 (25 set.
                            1920). Pág. 6-7.
                            <br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81896" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/48995" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-023.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La enseñanza musical en el Colegio de
                            los Sagrados Corazones / María Wiesse.
                            – Lima: editor no identificado, 1948.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/48995" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-002.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «DOS HAN SIDO SUS PRINCIPALES PASIONES, Y A LAS QUE DEBE LA EXCELENCIA DE SU ESPÍRITU: LA MÚSICA
                                Y LA LECTURA DE BUENAS OBRAS. SU PREPARACIÓN FUE LENTA Y SILENCIOSA, NO LANZÁNDOSE A ESCRIBIR,
                                NI A DESCUBRIR SU PERSONALIDAD, SINO CUANDO SE ENCINTRÓ CON FUERZAS SUFICIENTES, PARA
                                SOSTENERSE COMO ESCRITORA».<br><br>
                                (LA MUER PERUANA A TRAVÉS DE LOS SIGLOS / ELVIRA GARCÍA Y GARCÍA. TOMO II. 1925)
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            MARÍA WIESSE Y LA LITERATURA<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>
                <div class="row p-5">

                    <div class="col-sm-3"></div>
                    <div class="col-sm-6 ">
                        <br><br>
                        <p 
                            class="fontMS700 text-center colorPrincipal font-30">
                            POESÍA

                        </p>
                    </div>
                    <div class="col-sm-3"></div>
                </div>

                <p class="text-justify fontMS300 font-24">

                    A LA ACUSACIÓN QUE LE HICIERON DE SER ANTICUADA, MARÍA WIESSE RESPONDIÓ LO SIGUIENTE:
                    «MIENTRAS PUEDA Y CUANDO PUEDA NO DEJARÉ DE MOSTRAR A LAS MUJERES DEL HOGAR PEDACITO
                    PLENO DE CALOR Y DULZURA, EL AMOR Y LOS NIÑOS QUE ALEGRAN LA CASA CON SUS RISAS Y EL ALMA
                    CON SUS TERNURAS COMO EL MÁS BELLO IDEAL DE VIDA, COMO LA DICHA MÁS GRANDE. DICHA QUE
                    SUPERA AL PROGRESO MÁS AVANZADO, A TODAS LAS CONQUISTAS MÁS AUDACES DEL FEMINISMO, DICHA
                    HUMILDE, SENCILLA Y HONDA». (MUNDIAL. 15 DE ABRIL DE 1921).
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81817" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-024.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Glosas franciscanas / María Wiesse ;
                            maderas originales de José Sabogal. –
                            Lima: Imp. Lux, 1926.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81817" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81823" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-025.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Canciones / María Wiesse. – Lima: Imp.
                            Lux, 1934.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81823" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81803" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-026.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Trébol de cuatro hojas (Poemas) / María
                            Wiesse. – Lima: Compañía de
                            Impresiones y Publicidad, 1932.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81803" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81802" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-027.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            jabirú : diversiones al margen de la
                            poesía / maría wiesse. – lima: [C.I.P.],
                            1951.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81802" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                </div>


                <div class="row p-5">

                    <div class="col-sm-3"></div>
                    <div class="col-sm-6 ">
                        <br><br>
                        <p 
                            class="fontMS700 text-center colorPrincipal font-30">
                            CUENTO

                        </p>
                    </div>
                    <div class="col-sm-3"></div>
                </div>

                <p class="text-justify fontMS300 font-24">

                    COMO SE PUEDE APRECIAR, MARÍA WIESSE CULTIVÓ DIVERSOS GÉNEROS LITERARIOS, POR ELLO SE LE HA
                    CATALOGADO COMO UNA NARRADORA NETA. EN DIVERSOS CUENTOS, MARÍA WIESSE EMPLEA UN ESTILO
                    SIMPLE Y DIRECTO, EL CUAL LE PERMITIÓ CREAR TRAMAS SUTILES Y UNA CIERTA HONDURA PSICOLÓGICA
                    EN SUS PERSONAJES.
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-028.png">
                            <br>
                    </div>
                    <div class="col-sm-3">
                        <br>
                    </div>
                </div>

                <div class="row p-5">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81801" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-029.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Nocturnos / María Wiesse [Myriam] ;
                            maderas originales de José Sabogal. –
                            Lima: [Imp. Lux], 1925.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81801" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81794" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-030.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            nueve relatos / maría wiesse ; maderas
                            de josé sabogal. – Lima: [CIP], 1933.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81794" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81795" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-031.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Pequeñas historias (cuentos) / María
                            Wiesse. – Lima: CIP, 1951.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81795" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81793" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-032.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Linterna mágica (cuentos) / María
                            Wiesse. – Lima: Compañía de
                            Impresiones y Publicidad, 1954.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81793" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                </div>


                <div class="row p-5">

                    <div class="col-sm-3"></div>
                    <div class="col-sm-6 ">
                        <br><br>
                        <p 
                            class="fontMS700 text-center colorPrincipal font-30">
                            TEATRO

                        </p>
                    </div>
                    <div class="col-sm-3"></div>
                </div>

                <p class="text-justify fontMS300 font-24">
                    DURANTE SUS AÑOS ESCOLARES EN EL COLEGIO BELÉN, MARÍA WIESSE ESCRIBIÓ PEQUEÑAS OBRAS TEATRALES 
                    QUE ERAN REPRESENTADAS POR SUS COMPAÑERAS DE COLEGIO. POSTERIORMENTE, VARIAS DE SUS OBRAS 
                    TEATRALES (PASOS DE COMEDIA, ENTREMESES, DRAMAS) FUERON PRESENTADAS EN DIVERSAS SALAS DE LIMA 
                    Y CALLAO POR COMPAÑÍAS PROFESIONALES.  
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81800" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-033.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La hermana mayor: comedia en un acto
                            y tres cuadros ; El modistón: entremés /
                            María Wiesse. – Lima: Imp. del Centro
                            Editorial, 1918.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81800" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81897" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-034.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            María Magdalena: Evangelio en tres
                            cuadros / María Wiesse. Variedades :
                            revista semanal ilustrada. Año XVII, no.
                            682 (26 mar. 1921). Pág. 18-19.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81897" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81883" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-035.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La monja de la llave / María Wiesse.
                            Variedades : revista semanal ilustrada.
                            Año XXIV, no. 1055 (19 may. 1928), p.
                            [34]-[40] : il. ; Año XXIV, no. 1056 (26
                            may. 1928), p. [34]-[39] : il. ; Año XXIV,
                            no. 1057 (2 jun. 1928). Pág. 19-20.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81883" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/49004" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-036.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La oración fúnebre de Madame
                            Bourgeois / juguete cómico por M[aría].
                            W[iesse]. Julio de 1908. 3 ff.
                            Mecanografiado<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/49004" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br><br><br>
                        </p>
                    </div>
                </div>

                <div class="row p-5">

                    <div class="col-sm-3"></div>
                    <div class="col-sm-6 ">
                        <br><br>
                        <p 
                            class="fontMS700 text-center colorPrincipal font-30">
                            NOVELA

                        </p>
                    </div>
                    <div class="col-sm-3"></div>
                </div>

                <p class="text-justify fontMS300 font-24">
                    LAS NOVELAS DE MARÍA WIESSE SE CARACTERIZAN POR LA INCLUSIÓN DE ELEMENTOS 
                    DE LA CULTURA POPULAR. ASIMISMO, SE PUEDE APRECIAR HONDURA EN LA PRESENTACIÓN 
                    DE SUS PERSONAJES Y UNA ADECUADA TENSIÓN DRAMÁTICA QUE SE PLASMA, 
                    PRINCIPALMENTE, EN LOS DESENLACES DE SUS OBRAS.   
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81799" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-037.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La huachafita (ensayo de novela limeña)
                            / María Wiesse. – Lima: Imp. Lux, 1927.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81799" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81897" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-038.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            la casa frente al mar, novela. En: tríptico
                            / María Wiesse. – lima: [CIP], 1953.
                            Pág. 11.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81897" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81898" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-039.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Tutuche (historia de un niño) / María
                            Wiesse de Sabogal (Myriam). Variedades:
                            revista semanal ilustrada. Año XXIII, no.
                            996 (2 abr. 1927). Pág. 19-20.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81898" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81868" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-040.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La red / María Wiesse. Hora del hombre:
                            revista de cultura social. Año V, no.
                            52-54 (nov. 1947-ene. 1948). Pág. 3-12.
                            Epígrafe de la sección: Literatura.
                            Novela.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81868" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 180%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            MARIA WIESSE Y SU VISIÓN
                            DE LA MUJER<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>
                <!-- <div class="col-sm-1"></div> -->
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                </div>

                <div class="row ">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <p class="text-left text-white fontMS100 font-18">
                            <br><br>
                            MARÍA WIESSE FORMÓ PARTE DE DIVERSAS
                            AGRUPACIONES FEMENINAS EN LAS PRIMERAS
                            DÉCADAS DEL SIGLO XX Y ESTUVO VINCULADA CON
                            FIGURAS ESENCIALES DEL FEMINISMO PERUANO
                            COMO MARÍA JESÚS ALVARADO O MIGUELINA
                            ACOSTA CÁRDENAS. DEL MISMO MODO, FUE UNA DE
                            LAS FUNDADORAS DEL CONSEJO NACIONAL DE
                            MUJERES (1923), Y PARTICIPÓ ACTIVAMENTE EN LA
                            ORGANIZACIÓN DE LA SEGUNDA CONFERENCIA
                            PANAMERICANA DE MUJERES Y EL TERCER
                            CONGRESO CIENTÍFICO PANAMERICANO, REALIZADOS
                            EN LIMA ENTRE 1924 Y 1925. SIN EMBARGO, NO
                            ASUMIÓ UNA POSICIÓN SOBRE ASPECTOS SOCIALES
                            O POLÍTICOS RELACIONADOS CON LAS MUJERES; POR
                            EL CONTRARIO, DEFENDÍA EL PAPEL DE LAS MADRES
                            COMO SOSTENEDORAS DEL HOGAR Y DE LA
                            EDUCACIÓN DE LOS HIJOS.
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-4">
                        <br><br>
                        
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-041.png">
                        

                    </div>
                    <div class="col-sm-1"></div>


                    <div class="row p-5">
                        <div class="col mx-3 md-3">
                            <a href="http://hdl.handle.net/20.500.14428/81856" target="_blank" >
                                <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-042.png">
                            </a>
                            
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                <br><br>
                                Familia : publicación mensual ilustrada.
                                Año I, no. 1 (feb. 1919).<br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/81856" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br><br><br><br>
                            </p>
                        </div>
                        <div class="col mx-3 md-3">
                            <a href="http://hdl.handle.net/20.500.14428/81855" target="_blank" style="color: #ffffff;">
                                <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-043.png">
                            </a>
                            
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                <br><br>
                                El trabajo de la mujer en Lima / Myriam
                                [seud.]. El Perú: edición de la mañana
                                (17 ene. 1917). Pág. 3.<br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/81855" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br><br>
                            </p>
                        </div>
                        <div class="col mx-3 md-3">
                            <a href="http://hdl.handle.net/20.500.14428/81854" target="_blank" style="color: #ffffff;">
                                <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-044.png">
                            </a>
                            
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                <br><br>
                                Crónicas femeninas: Para ser hermosas /
                                Myriam [seud.]. El Día: diario de la
                                mañana (26 abr. 1917). Pág. 5.<br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/81854" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br><br>
                            </p>
                        </div>
                        <div class="col mx-3 md-3">
                            <a href="http://hdl.handle.net/20.500.14428/81845" target="_blank" style="color: #ffffff;">
                                <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-045.png">
                            </a>
                            
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                <br><br>
                                La vida femenina / Myriam [seud.].
                                Revista de Actualidades: semanario
                                ilustrado. No. 2 (7 jul. 1917). Pág. 24-25.<br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/81845" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br>
                            </p>
                        </div>
                    </div>
    
                    <div class="row p-5">
                        <div class="col-sm-1"></div>
                        <div class="col mx-3 md-3">
                            <a href="http://hdl.handle.net/20.500.14428/81902" target="_blank" >
                                <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-046.png">
                            </a>
                            
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                <br><br>
                                Levedades / Myriam [seud.]. Mundial.
                                Año II, no. 50 (8 abr. 1921). Pág. 36-37.<br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/81902" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br><br><br><br>
                            </p>
                        </div>
                        <div class="col mx-3 md-3">
                            <a href="http://hdl.handle.net/20.500.14428/81857" target="_blank" style="color: #ffffff;">
                                <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-047.png">
                            </a>
                            
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                <br><br>
                                La mujer limeña en las Tradiciones / por
                                María Wiesse. Hora del hombre: revista
                                de cultura social. Año II, No. 15 (oct.
                                1944). Pág. 18-19.<br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/81857" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br>
                            </p>
                        </div>
                        <div class="col mx-3 md-3">
                            <a href="https://hdl.handle.net/20.500.14428/48948" target="_blank" style="color: #ffffff;">
                                <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-048.png">
                            </a>
                            
                            <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                <br><br>
                                Santa Rosa y su basílica / [María
                                Wiesse]. [1920]. 10 ff.
                                Manuscrito.<br>
                                Disponible en: <a href="https://hdl.handle.net/20.500.14428/48948" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br><br><br><br>
                            </p>
                        </div>
                        <div class="col-sm-1"></div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            ARTÍCULOS Y ENSAYOS<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>

                <p class="text-center fontMS300 font-24">
                    <br><br>
                    DESDE JOVEN, MARÍA WIESSE ESTUVO LIGADA AL PERIODISMO A TRAVÉS DE SUS
                    COLABORACIONES EN DIVERSOS MEDIOS COMO LA CRÓNICA, EL PERÚ, EL DÍA, REVISTA DE
                    ACTUALIDADES, VARIEDADES, FAMILIA, MUNDIAL, AMAUTA, SOCIAL Y HORA DEL HOMBRE.
                    EN SUS MÚLTIPLES ESCRITOS, LA AUTORA DEMOSTRÓ VASTA CULTURA Y UN ESTILO MUY AMENO,
                    QUE LE PERMITIERON TRATAR CON LA MISMA FACILIDAD UN TEMA CIENTÍFICO, LITERARIO O DE LA
                    VIDA COTIDIANA.
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81814" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-049.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Croquis de viaje / María Wiesse ;
                            maderas originales de José Sabogal. –
                            Lima: Librería Francesa Científica y Casa
                            Editorial E. Rosay, 1924.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81814" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81815" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-050.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            José María Córdova (1799-1829) /
                            ensayo biográfico por María Wiesse ;
                            prólogo de Fabio Lozano y Lozano. –
                            Lima: Tip. La Voce D´Italia, 1924.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81815" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81816" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-051.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            José Carlos Mariátegui (etapas de su
                            vida) / María Wiesse. – Lima: Ediciones
                            Hora del Hombre, 1945.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81816" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81798" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-052.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            josé sabogal, el artista y el hombre / un
                            relato por maría wiesse. – lima: [Cía. de
                            Impresiones y Publicidad], 1957.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81798" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            CRÍTICA LITERARIA<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>

                <p class="text-center fontMS300 font-24">
                    <br><br>
                    «PARA EL CRÍTICO LITERARIO ALBERTO ESCOBAR, MARÍA REPRESENTA “UN NOTABLE EJEMPLO DE FE
                    EN LOS VALORES LITERARIOS Y ESTÉTICOS”. LUIS ALBERTO SÁNCHEZ AÑADE: “HIZO ALGO MÁS: LOS
                    CREÓ”. SU VIDA FUE UNA BATALLA SIN TREGUA POR, COMO DIRÍA MARIÁTEGUI, “LA CONQUISTA DE
                    LA BELLEZA, DEL ARTE, DEL PENSAMIENTO Y DE TODAS LAS COMPLACENCIAS DEL ESPÍRITU”»<br>
                    (JORGE WIESSE).
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81808" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-053.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Elementos de la poesía de Eguren /
                            María Wiesse. Amauta. Año IV, no. 21
                            (feb.-mar. 1929). Pág. 47-48.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81808" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81811" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-054.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El mensaje de José Carlos Mariátegui /
                            María Wiesse. Amauta. Año V, no. 30
                            (abr.-may. 1930). Pág. 41-42.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81811" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81877" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-055.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Semblanza de Clemente Palma / por
                            María Wiesse. Hora del hombre: revista
                            mensual de cultura social. Año IV, no.
                            38-39 (set.-oct. 1946). Pág. 17-22.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81877" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81866" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-056.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El dolor de Marcel Proust / por María
                            Wiesse. Social: la revista para todos. Año
                            XXIII, no. 404 (oct. 1953). Pág. 17.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81866" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-002.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «PROBABLEMENTE DEBIDO A LAS PUGNAS IDEOLÓGICAS --QUE PROSCRIBIERON LEGALMENTE A LOS
                                SEGUIDORES DE MARIÁTEGUI Y DE HAYA DE LA TORRE POR CASI UN CUARTO DE SIGLO--, LA OBRA DE MARÍA
                                NO TUVO EL ALCANCE NI LA ATENCIÓN QUE MERECIÓ. NADA DE ELLO LA ARREDRÓ; NI LOS ATAQUES AL
                                INDIGENISMO DE SU MARIDO NI EL SILENCIO DEL MEDIO ANTE SUS PROYECTOS EDITORIALES, VARIOS DE
                                ELLOS COSTEADOS CON FONDOS PROPIOS. VIVIÓ EN COMPLETA AUSTERIDAD, VOLCADA A LA LITERATURA Y
                                A LA MÚSICA. CUANDO LA REVISTA SOCIAL LA ENTREVISTÓ EN 1948, UNA RESPUESTA SUYA LA PINTÓ DE
                                CUERPO ENTERO: “EL ESCRITOR DE NUESTRO TIEMPO NO PUEDE SUSTRAERSE A LA INQUIETUD NI AL DRAMA
                                DE SU SIGLO”».<br><br>
                                (EL FUEGO DE LOS RECUERDOS / RICARDO WIESSE. EN: QUIPUS / MARÍA WIESSE. 2019g)
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-003.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            DONACIÓN MARÍA WIESSE<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>

                <p class="text-center fontMS300 font-24">
                    <br><br>
                    EN MAYO DE 1987, LA FAMILIA DE MARÍA WIESSE HIZO ENTREGA, EN CALIDAD DE DEPÓSITO, A LA
                    BIBLIOTECA NACIONAL DEL PERÚ, DE LOS ORIGINALES DE LA OBRA DE LA AUTORA DE EL NIÑO,
                    ESE DESCONOCIDO. ESTE MATERIAL INCLUYÓ LOS APUNTES DE SUS AUDICIONES RADIALES,
                    RECORTES DE ARTÍCULOS QUE PUBLICARA EN DIFERENTES PERIÓDICOS Y REVISTAS, RECORTES DE
                    TEXTOS SOBRE SU OBRA, MANUSCRITOS Y MATERIAL MECANOGRAFIADO ASÍ COMO OBJETOS
                    PERSONALES.
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col-sm-7">
                        <a href="https://hdl.handle.net/20.500.14428/50281" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-057.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Souvenir of first communion. Lonmdon, 1901.<br><br>
                            Exhibe el recuerdo de la primera comunión de la escritora y poetisa María Jesús
                            Isabel Wiesse Romero realizado en el Corpus Christi Day de 1901.
                            Código: XMW 010 (Fondo Antiguo). Donativo de Isabel Sabogal Málaga (BNP)<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/50281" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-4">

                        <div class="row">
                            <div class="col-sm-12">
                                <a href="https://hdl.handle.net/20.500.14428/49586" target="_blank" style="color: #ffffff;">
                                    <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-058.png">
                                </a>
                                
                                <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                    <br><br>
                                    Colegio de los Sagrados Corazones de Jesús y de María de la
                                    Adoración Perpetua 1 Clase: Certificado de notas de la
                                    señorita M. Wiesse. 1907.<br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/49586" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-12">
                                <a href="http://hdl.handle.net/20.500.14428/81849" target="_blank" style="color: #ffffff;">
                                    <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-059.png">
                                </a>
                                
                                <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                    <br><br>
                                    Carné de lectora de la Biblioteca Nacional de
                                    María Wiesse.<br>
                                    Disponible en: <a href="http://hdl.handle.net/20.500.14428/81849" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-12">
                                <a href="https://hdl.handle.net/20.500.14428/49270" target="_blank" style="color: #ffffff;">
                                    <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-060.png">
                                </a>
                                
                                <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                                    <br><br>
                                    Tarjeta de acreditación de El Universal Ilustrado:
                                    semanario artístico popular. México, 8 de mayo de 1923.<br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/49270" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                    <br><br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row p-5">
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/48734" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-061.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Diploma acreditando a María Wiesse como
                            socia fundadora de la Sociedad Cultural
                            «Ínsula». 1 de febrero de 1960.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/48734" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/48735" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-062.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Diploma acreditando a María Wiesse como
                            Presidenta Honoraria de la Sociedad
                            Cultural «Ínsula». 1 de febrero de 1960.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/48735" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81812" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-063.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Carta de María Wiesse a Guillermo Lazarte
                            Echegaray. Lima, 16 de julio de 1961. 1 f.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81812" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio34\FERNANDOG-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 p-3">
                        <p class="fontMS100 text-white font-24">
                            En referencia a la obra de María Wiesse, Ricardo Wiesse sostuvo lo siguiente:
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-12 p-3">
                        <p class="fontMS100 text-white font-24 text-justify">
                            «Desconocida en escuelas y universidades, la obra de María Wiesse languidece desde hace medio siglo. No hay, en su ciudad natal
                            ni en el distrito donde vivió y murió, una sola alusión —placa, calle, plaza, institución educativa, asociación cultural— que la
                            recuerde. El peruano contemporáneo crece sin otros referentes creativos que los grandes nombres, varones en su gran mayoría.
                            Desestima la labor cimentadora de quienes despejaron la tierra inculta y trazaron vías sensibles para ser transitadas por los
                            espectadores, lectores o auditores anónimos del futuro».
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            a) ¿Cuáles son las posturas
                            intelectuales de la autora? ¿Por qué
                            cree que la crítica literaria no ha
                            reconocido los valores de su obra?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            b) Seleccione uno de los cuentos
                            de Linterna mágica y comente lo
                            que más le ha llamado la atención.

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            c) Le invitamos a escribir una carta a
                            uno de sus amigos o familiares
                            compartiendo su lectura sobre María
                            Wiesse y enviarla por correo postal.
                            ¿Qué diferencias encuentra con la
                            comunicación por redes sociales?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#bb32ac;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 text-left font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Bustamante, C. (1981). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Intelectuales peruanas de la
                                generación de José Carlos Mariátegui. Socialismo y
                                Participación. No. 14, p. 107-119.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Delgado, M. (2020). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">María Wiesse en Amauta: los
                                orígenes de la crítica de cine en el Perú. Lima: Editorial<br>
                                <!-- Gafas Moradas EIRL.
                                <br><br>
                                Disponible en: 
                                <a style="color: #000000;" href="https://doi.org/10.1590/1982-25532020144547" target="_blank">
                                https://doi.org/10.1590/1982-25532020144547</a>
                                <br> -->
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">García y García, E. (1924-1925). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">María J. Wiesse de
                                Sabogal. En: La mujer peruana a través de los siglos.
                                Tomo II. Lima: Imprenta Americana. – p. 124-125.<br></span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Guardia, S. (2013). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Mujeres peruanas. El otro lado de
                                la historia. Quinta edición. Lima: Edición de autor.
                                <br></span>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Guardia, S. (2016). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">José Carlos Mariátegui. Una visión
                                de género. Segunda edición. Lima: Edición de autor.
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Márquez, M.A. (1969). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">María Wiesse de Sabogal.
                                Anuario Bibliográfico Peruano 1964-1966. Lima:
                                Biblioteca Nacional del Perú, p. 719-732.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Wiesse, R. (2014). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Letra y música de María Wiesse.
                                Lima: Instituto de Estudios Peruanos.
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Wiesse, R. (2019). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">El fuego de los recuerdos. Sobre
                                Quipus. En Wiesse, M. Quipus: relatos peruanos para
                                niños. Lima: Fundación SM, p. 115-130.
                            </span>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
